import { I18nProvider as LingUiProvider } from '@lingui/react';
import { i18n } from '@lingui/core';
import { setLocale } from 'features/i18n';

type I18nProviderProps = {
  children: React.ReactNode;
};

setLocale();

export const I18nProvider = ({ children }: I18nProviderProps) => {
  return <LingUiProvider i18n={i18n}>{children}</LingUiProvider>;
};
